import StatusModal, {StatusModalStates} from 'components/StatusModal';
import {useTranslation} from 'react-i18next';
import styles from './styles.module.css';

type Props = {
  isOpen: boolean;
  status: StatusModalStates;
};

function SearchingBookingModal({isOpen, status}: Props) {
  const {t} = useTranslation();

  return (
    <StatusModal
      open={isOpen}
      state={status}
      maxWidth="675px"
      className="searching-booking-modal"
    >
      {status === StatusModalStates.LOADING && (
        <div className={styles.statusTitleModal}>{t('searching_booking')}</div>
      )}
      {status === StatusModalStates.SUCCESS && (
        <div className={styles.statusTitleModal}>{t('booking_found')}</div>
      )}
    </StatusModal>
  );
}

export {SearchingBookingModal};
